import { render, staticRenderFns } from "./SacTreatmentsTotalAttendances.vue?vue&type=template&id=2b62bf57&"
import script from "./SacTreatmentsTotalAttendances.vue?vue&type=script&lang=js&"
export * from "./SacTreatmentsTotalAttendances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports